import { MediaAnalysisProgress, MediaAnalysisStatus } from '@/common/model/media/mediaAnalysis'
import { QueryFanoutResult } from '@/common/model/media/queryFanout'
import { SentimentResult } from '@/common/model/media/sentiment'
import { ShareOfVoiceResult } from '@/common/model/media/shareOfVoice'

export const LlmoApiPath = {
  RUN_LLMO_ANALYSIS: '/api/sites/{site_id}/llmo/run', // POST Run Llmo Analysis（バックグラウンド実行）
  GET_LLMO_HISTORY_DETAIL: '/api/sites/{site_id}/llmo/history/{history_id}', // GET Get Llmo History Detail
  COMPARE_WITH_PREVIOUS: '/api/sites/{site_id}/llmo/compare/{history_id}' // GET Compare With Previous
}

export type LlmoApiPath = (typeof LlmoApiPath)[keyof typeof LlmoApiPath]

// バックグラウンド実行の入力。分析対象（media_analysis_target_id）から入力を解決する
export interface RunLlmoAnalysisVars {
  site_id: number
  media_analysis_target_id?: number | null
  own_brand?: string
  own_url?: string
  competitor_brands?: string[] | null
  competitor_urls?: string[] | null
  category?: string
  analysis_type: string
}

export interface GetLlmoHistoryDetailVars {
  site_id: number
  history_id: number
}

export interface CompareWithPreviousVars {
  site_id: number
  history_id: number
}

export interface RunLlmoAnalysisResponse {
  id: number
  analysis_type: string
  status: string // analyzing
}

export interface GetLlmoHistoryDetailResponse {
  id: number
  analysis_type: string
  input: Record<string, unknown>
  result: Record<string, unknown>
  status?: MediaAnalysisStatus
  progress?: MediaAnalysisProgress
  created_at: string | null
}

// 分析が失敗した場合、result には表示用のエラーメッセージのみが入る
// （backend/services/media_analysis_runner.py::fail_analysis_record）
export interface AnalysisResultError {
  error?: string
}

// 履歴詳細の result を分析種別ごとに型付けしたもの。結果詳細画面が useLlmoAnalysisDetailApi の
// 型引数に渡して使う
export interface ShareOfVoiceHistoryDetailResponse extends Omit<
  GetLlmoHistoryDetailResponse,
  'result'
> {
  result: ShareOfVoiceResult & AnalysisResultError
}

export interface SentimentHistoryDetailResponse extends Omit<
  GetLlmoHistoryDetailResponse,
  'result'
> {
  result: SentimentResult & AnalysisResultError
}

export interface QueryFanoutHistoryDetailResponse extends Omit<
  GetLlmoHistoryDetailResponse,
  'result'
> {
  result: QueryFanoutResult & AnalysisResultError
}

// 前回結果との比較。diff の内容は分析種別ごとに異なる
// （backend/routers/llmo_analysis.py::compare_with_previous 参照）
export interface CompareWithPreviousResponse {
  available: boolean
  message?: string | null
  analysis_type?: string
  previous?: { id: number; created_at: string | null }
  current?: { id: number; created_at: string | null }
  diff?: {
    // sentiment
    score_change?: number
    previous_score?: number
    current_score?: number
    // query_fanout
    persistence_change?: number
    previous_persistence?: number
    current_persistence?: number
  }
}
